<template>
  <div class="message-content">
    <div class="btnGroup">
      <div class="tips">您有{{ messageNum || 0 }}条信息未读，请及时查看。</div>
      <div class="btns">
        <a-button type="primary" @click="changeRead">标记本页为已读</a-button>
        <a-button type="primary" @click="onDeletePage">删除本页提醒</a-button>
      </div>
    </div>
    <div class="messagelist">
      <a-list
        item-layout="horizontal"
        :pagination="{
          ...pagination,
          hideOnSinglePage: true,
          onChange: (page) => $emit('changePagi', page),
        }"
        :dataSource="messageList"
      >
        <a-list-item slot="renderItem" slot-scope="item">
          <template slot="actions">
            <div class="handle">
              <a-tag
                color="green"
                v-if="item.informationStatus === 'UNDEAD'"
                @click="oneChangeStu(item.id)"
                >标记为已读</a-tag
              >
              <a-tag color="red" v-else @click="oneDelete(item.id)">删除</a-tag>
            </div>
          </template>
          <a-list-item-meta>
            <template slot="description">
              <div class="description-item">
                <div class="badge-msg">
                  <div
                    class="red-dian"
                    v-if="item.informationStatus === 'UNDEAD'"
                  ></div>
                  <div class="msg">{{ item.information || "" }}</div>
                </div>
                <div
                  :class="{
                    time: true,
                    active: item.informationStatus === 'UNDEAD',
                  }"
                >
                  {{ item.dateCreated || "" }}
                </div>
              </div>
            </template>
          </a-list-item-meta>
        </a-list-item>
      </a-list>
    </div>
  </div>
</template>
<script>
export default {
  props: ["messageList", "pagination", "messageNum"],
  data() {
    return {};
  },
  methods: {
    changeRead() {
      let list = this.messageList;
      let ids = [];
      list.map((item) => {
        if (item.informationStatus === "UNDEAD") {
          ids.push(item.id);
        }
      });
      this.$emit("onChangeMessage", { ids, informationStatus: "READ" });
    },
    onDeletePage() {
      let list = this.messageList;
      let ids = [];
      list.map((item) => {
        if (item.informationStatus === "READ") {
          ids.push(item.id);
        }
      });
      this.$emit("onDeletePagemsg", { ids });
    },
    oneChangeStu(id) {
      let ids = [id];
      this.$emit("onChangeMessage", { ids, informationStatus: "READ" });
    },
    oneDelete(id) {
      let ids = [id];

      this.$emit("onDeletePagemsg", { ids });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../../utils/convertPxToDesighViewport/convertPxToDesighViewport";
//.convertPxToDesighVH(20)[] .convertPxToDesighVW(20)[]
.message-content {
  width: 100%;
  > .btnGroup {
    display: flex;
    align-items: center;
    justify-content: space-between;
    > .tips {
      font-size: .convertPxToDesighVH(14) [];
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #e2f2ff;
    }
    > .btns {
      > .ant-btn:first-of-type {
        margin-right: .convertPxToDesighVW(20) [];
      }
    }
  }
  > .messagelist {
    margin-top: .convertPxToDesighVH(20) [];
    > ::v-deep.ant-list {
      > .ant-spin-nested-loading {
        > .ant-spin-container {
          > .ant-list-items {
            > .ant-list-item {
              background: #091121;
              border-radius: .convertPxToDesighVH(20) [];
              > .ant-list-item-meta {
                > .ant-list-item-meta-content {
                  > .ant-list-item-meta-description {
                    > .description-item {
                      > .badge-msg {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        > .red-dian {
                          width: .convertPxToDesighVW(8) [];
                          height: .convertPxToDesighVH(8) [];
                          background: #dd6d22;
                          border-radius: 50%;
                        }
                        > .msg {
                          margin-left: .convertPxToDesighVW(15) [];
                          font-size: .convertPxToDesighVH(14) [];
                          font-family: Source Han Sans CN;
                          font-weight: 400;
                          line-height: .convertPxToDesighVH(24) [];
                          color: #aeb0b6;
                        }
                      }
                      > .time {
                        margin-left: .convertPxToDesighVW(15) [];
                        color: #909ca6;
                      }
                      > .time.active {
                        margin-left: .convertPxToDesighVW(23) [];
                      }
                    }
                  }
                }
              }
              > .ant-list-item-action {
                > li {
                  > .handle {
                    .ant-tag {
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      // height: 32px;
                      border-radius: .convertPxToDesighVH(5) [];
                      font-size: .convertPxToDesighVH(14) [];
                      font-family: Microsoft YaHei;
                      font-weight: 400;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
